<div class="user-config-container">
  <form [formGroup]="userDataForm">
    <div class="user-data-container">
      @if (user() && !user()?.isNew) {
        <mat-form-field>
          <mat-label>User ID</mat-label>
          <input matInput formControlName="userId" readonly />
        </mat-form-field>
      }
      <mat-form-field>
        <mat-label>User Name</mat-label>
        <input matInput formControlName="userName" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>User Role</mat-label>
        <mat-select formControlName="role">
          @for (role of roles; track role) {
            <mat-option [value]="role">{{ role }} </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-checkbox formControlName="canAccessChat">Can access chat</mat-checkbox>
      @if (user() && !user()?.isNew) {
        <button
          class="reset-password-button"
          mat-raised-button
          color="primary"
          (click)="openChangePassword()">
          Reset Password
        </button>
      }
    </div>
  </form>
  <div>
    <app-registration-list
      [userRegistration]="user()"
      (newItemEvent)="selectedTools.set($event)"></app-registration-list>
  </div>
</div>
<div class="control">
  <button mat-raised-button color="primary" (click)="apply()">Apply</button>
</div>
